export const PACKAGE_VERSION = "0.50.0";
